/** Branching and Merging related events that can occur on main and branch design applications */

import { DesignBranchingEventType } from "../../types";

let registeredBranchMergeEventFactories = {};

// "init-branchingMap" = a new branch to be tracked by main 
registeredBranchMergeEventFactories[DesignBranchingEventType.initBranchingMap] = (eventData) => {
	return {
		type: DesignBranchingEventType.initBranchingMap,
		branch_name: eventData.featureBranch.application,
		branch_id: eventData.featureBranch._id,
		branched_at: eventData.mainBranch.version,
		timestamp: eventData.timestamp,
		author: eventData.author
	};
};

// "merge" = a branch merged into main
registeredBranchMergeEventFactories[DesignBranchingEventType.merge] = (eventData) => {
	return {
		type: DesignBranchingEventType.merge,
		branch_name: eventData.application,
		branch_id: eventData.branchId,
		merged_at: eventData.branchVersion,
		timestamp: eventData.timestamp,
		author: eventData.author
	};
};

// "init" = branch created event to be tracked by branch
registeredBranchMergeEventFactories[DesignBranchingEventType.initBranch] = (eventData) => {
	return {
		type: DesignBranchingEventType.initBranch,
		branched_at: eventData.mainBranch.version,
		parent_branch_id: eventData.mainBranch._id,
		parent_branch_name: eventData.mainBranch.application,
		timestamp: eventData.timestamp,
		author: eventData.author
	};
};

// "pull" = main merged into branch
registeredBranchMergeEventFactories[DesignBranchingEventType.pull] = (eventData) => {
	return {
		type: DesignBranchingEventType.pull,
		pulled_at: eventData.version,
		parent_application: eventData.parentApplication,
		timestamp: eventData.timestamp,
		author: eventData.author
	};
};

export default class BranchMergeEventFactory {
	getEvent(type, eventData) {
		return registeredBranchMergeEventFactories[type](eventData);
	}
}
